import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';
import { UrlDev } from './../../url';

const DoorCollection = ({ value, onChange, label = 'Panel Collection' }) => {
    const [selectedDoorCollection, setSelectedDoorCollection] = useState(value || "");
    const [options, setOptions] = useState([]);

    useEffect(() => {
 
        fetch(`${UrlDev}/panelcollection/`) 
            .then((response) => response.json())
            .then((data1) => {
                let data = data1;
            	const activeOptions = data.filter(option => option.active);
            	setOptions(activeOptions);
            })
            .catch((error) => {
                console.error("Error fetching items:", error);
                alert("An error occurred while fetching items.");
            });

      }, []);
      

    const handleDoorCollectionChange = (e) => {
        const newValue = e.target.value;
        setSelectedDoorCollection(newValue);
        onChange(newValue);
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorCollection">{label}</label>
            <select
                id="DoorCollection"
                value={selectedDoorCollection}
                onChange={handleDoorCollectionChange}
            >
                {options.map(option => (
                    <option key={option.id} value={option.title}>
                        {selectedDoorCollection === option.title ? `${option.title} ✔` : option.title}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default DoorCollection;